<template>
    <v-layout row fill-height align-center justify-center style="width:100%">
        <v-flex md12 lg10>
            <v-card v-if="selectedFollowUp.question.complete === false" class="height-max">
                <v-progress-linear v-model="percentProgress" class="my-0"></v-progress-linear>
                <v-container
                    fluid
                    grid-list-xs
                >
                    <v-layout row>
                        <v-flex xs12>
                            <div v-if="selectedFollowUp.question.score_instructions">
                                <h3 v-html="selectedFollowUp.question.score_instructions" class="font-weight-regular"></h3>
                                <v-divider class="my-4"></v-divider>
                            </div>
                            <div v-if="selectedFollowUp.question.score_group_name">
                                <h3>{{ selectedFollowUp.question.score_group_name}}</h3>
                                <p v-html="selectedFollowUp.question.score_group_instructions"></p>
                            </div>
                        </v-flex>

                    </v-layout>

                    <v-layout align-center justify-center row v-if="!selectedFollowUp.question.special_type">
                        <v-flex xs12 sm8 offset-sm2>
                            <h2 class="my-4 question-title" v-html="selectedFollowUp.question.score_question_text"></h2>
                            <div class="custom-radio">
                                <div class="radio mb-2"
                                     v-for="answer in selectedFollowUp.question.score_question_answer"
                                     :key="answer.id">
                                    <input type="radio" name="answer" :value="answer.id" v-model="response" :disabled="markAsDisabled"
                                           @change="sendAnswer()"
                                           :id="'answer'+answer.id">
                                    <label class="v-label theme--light" :for="'answer'+answer.id">{{answer.text}}<span
                                        v-if="answer.remarks" v-html="'<br>' + answer.remarks"></span></label>
                                </div>
                            </div>
                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-else-if="selectedFollowUp.question.special_type === 'scale'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="selectedFollowUp.question.score_question_text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-slider
                                    :min="0"
                                    :max="selectedFollowUp.question.score_question_answer.length - 1"
                                    ticks
                                    always-dirty
                                    v-model="slider_value"
                                    :tick-labels="getTicksLabels()"
                                    @change="updateResponse()"
                                    :disabled="markAsDisabled"
                                    tick-size="0"
                                    thumb-label="always"
                                    class="mb-4">
                                        <template v-slot:prepend>
                                            {{ selectedFollowUp.question.score_question_answer[0].remarks }}
                                        </template>
                                        <template v-slot:thumb-label="props">
                                          <span>
                                            {{ selectedFollowUp.question.score_question_answer[props.value].value }}
                                          </span>
                                        </template>
                                        <template v-slot:append>
                                            {{ selectedFollowUp.question.score_question_answer[selectedFollowUp.question.score_question_answer.length - 1].remarks }}
                                        </template>
                                    </v-slider>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>
                    <v-layout align-center justify-center row v-else-if="selectedFollowUp.question.special_type === 'scale_no_label'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="selectedFollowUp.question.score_question_text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-slider
                                        :min="0"
                                        :max="selectedFollowUp.question.score_question_answer.length - 1"
                                        ticks
                                        always-dirty
                                        v-model="slider_value"
                                        @change="updateResponse()"
                                        :disabled="markAsDisabled"
                                        tick-size="0"
                                        class="mb-4">
                                        <template v-slot:prepend>
                                            {{ selectedFollowUp.question.score_question_answer[0].remarks }}
                                        </template>
                                        <template v-slot:thumb-label="props">
                                          <span>
                                            {{ selectedFollowUp.question.score_question_answer[props.value].text ? selectedFollowUp.question.score_question_answer[props.value].text : selectedFollowUp.question.score_question_answer[props.value].value }}
                                          </span>
                                        </template>
                                        <template v-slot:append>
                                            {{ selectedFollowUp.question.score_question_answer[selectedFollowUp.question.score_question_answer.length - 1].remarks }}
                                        </template>
                                    </v-slider>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>
                    <v-layout align-center justify-center row v-else-if="selectedFollowUp.question.special_type === 'scale_degree'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="selectedFollowUp.question.score_question_text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-slider
                                        :min="0"
                                        :max="selectedFollowUp.question.score_question_answer.length - 1"
                                        ticks
                                        always-dirty
                                        v-model="slider_value"
                                        :tick-labels="getTicksLabels()"
                                        @change="updateResponse()"
                                        :disabled="markAsDisabled"
                                        tick-size="0"
                                        class="mb-4">
                                    </v-slider>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-else-if="selectedFollowUp.question.special_type === 'scale_select_degree'">
                        <v-flex xs12 sm10 offset-sm1>
                            <h2 class="my-4 question-title" v-html="selectedFollowUp.question.score_question_text"></h2>

                            <v-layout>
                                <v-flex xs12>
                                    <v-select
                                        v-model="slider_value"
                                        :items="selectedFollowUp.question.score_question_answer"
                                        @change="updateResponse()"
                                        :disabled="markAsDisabled"
                                    ></v-select>
                                </v-flex>

                            </v-layout>

                        </v-flex>
                        <v-spacer></v-spacer>
                    </v-layout>

                    <v-layout align-center justify-center row v-if="!selectedFollowUp.question.special_type">
                        <v-flex xs3 text-xs-left>
                            <v-btn text color="primary" @click="removeLast()">
                                {{ $t('previous')}}
                            </v-btn>
                        </v-flex>
                        <v-flex xs3 offset-xs3 text-xs-right>
                            <v-btn v-if="response && false" text color="primary" @click="sendAnswer()">
                                {{ $t('next')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout align-center justify-center row v-else>
                        <v-flex xs3 text-xs-left>
                            <v-btn text color="primary" @click="removeLast()">
                                {{ $t('previous')}}
                            </v-btn>
                        </v-flex>
                        <v-flex xs3 offset-xs3 text-xs-right>
                            <v-btn text color="primary" @click="sendAnswer()">
                                {{ $t('next')}}
                            </v-btn>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-card>
            <v-card v-if="selectedFollowUp.question.complete" class="pa-4">
                <v-card-title>
                    <v-layout column mt-4>
                        <v-flex pa-2>
                            <h2>{{$t('followUpCompleted')}}</h2>
                        </v-flex>
                        <v-flex px-2>
                            <span class="title">{{$t('followUpCompletedMessage')}}</span>
                            <p v-if="completedNextUrl">
                                {{$t('followUpCompletedNextMessage')}}<br>
                                <a :href="completedNextUrl">{{$t('followUpCompletedNextMessageClickHere')}}</a>
                            </p>
                        </v-flex>
                    </v-layout>
                </v-card-title>
            </v-card>

        </v-flex>
    </v-layout>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex'
    import axios from 'axios'

    export default {
        name: "PatientScoreView",
        props: {
            listener: Function
        },
        data() {
            return {
                response: null,
                btn_next: false,
                percentProgress: 0,
                slider_value: 0,
                markAsDisabled: false
            }
        },
        created() {
            //this.setSelectedTreatmentId(this.$route.params.treatment_id)
            //this.setSelectedFollowUpId(this.$route.params.follow_up_id)

        },
        mounted() {
            this.getCurrentQuestion()
        },
        computed: {
            locale() {
                return this.$i18n.locale
            },
            ...mapState('treatments', {
                selectedTreatment: state => state.selectedTreatment,
            }),
            ...mapState('follow_ups', {
                selectedFollowUp: state => state.selectedFollowUp,
                concern: state => state.concern,
                completedNextUrl: state => state.selectedFollowUp.question.next_link
            })

        },
        methods: {
            ...mapMutations(['updateLockedState', 'setLockedBack']),
            ...mapMutations('treatments', [
                'setSelectedTreatmentId',
            ]),
            ...mapMutations('medical_cases', [
                'setSelectedMedicalCase',
                'setMedicalCasePostUrl'
            ]),
            ...mapMutations('patients', [
                'setSelectedPatient',
                'setFormTegner',
                'setTegnerUrl'
            ]),
            ...mapMutations('follow_ups', [
                'setSelectedFollowUpId',
                'setFollowUpStatus',
                'setFollowUpName',
                'setMedicalCaseName',
                'setCompletedNextUrl',
                'setNextUrl',
                'setLastUrl',
                'setSelectedFollowUpId',
            ]),
            ...mapActions('follow_ups', [
                'getQuestionFromNotification', 'updateQuestionFromNotification', 'removeLastAnswerFromNotification', 'openFollowUpFromNotification'
            ]),

            getCurrentQuestion(){
                this.getQuestionFromNotification().then(response => {
                    this.refreshProgress()
                    if (response.data.follow_up.special_type && response.data.follow_up.special_type.startsWith("scale")) {
                        this.updateResponse()
                    }
                }).catch(reason => {
                    //Stay here..
                })
            },

            getTicksLabels() {

                if (this.selectedFollowUp.question.score_question_answer != null) {
                    return this.selectedFollowUp.question.score_question_answer.map(answer => answer.text)
                }
                return []
            },
            updateResponse() {
                if (this.slider_value != null) {
                    this.response = this.selectedFollowUp.question.score_question_answer[this.slider_value].id
                }
            },
            sendAnswer() {
                this.markAsDisabled = true
                this.$nextTick(function () {
                        setTimeout(() => {
                            if (this.response !== null) {
                                this.updateQuestionFromNotification({score_question_answer_id: this.response, concern: this.concern}).then(response => {
                                    this.response = null
                                    this.btn_next = false
                                    this.refreshProgress()
                                    this.slider_value = 0
                                    if (response.data.follow_up.special_type && response.data.follow_up.special_type.startsWith("scale")) {
                                        this.updateResponse()
                                    }

                                    if (this.completedNextUrl) {
                                        setTimeout(this.redirectToNext,5000)
                                    }

                                    this.markAsDisabled = false
                                }).catch(reason => {
                                    if (reason.response.data.status === 'redirect') {
                                        this.openFollowUpFromNotification({
                                            concern: this.$route.params.concern,
                                            signature: this.$route.params.hash,
                                            axios: axios
                                        }).then(response => {
                                            this.setFollowUpStatus(response.data.follow_up_status)
                                            this.setFollowUpName(response.data.step.name)
                                            this.setMedicalCaseName(response.data.follow_up.treatment.medical_case.name);

                                            if (this.status === 'incomplete') {
                                                this.setSelectedPatient(response.data.patient)
                                                this.setFormTegner(response.data.patient.tegner)
                                                this.setSelectedMedicalCase(response.data.medical_case)
                                                this.setMedicalCasePostUrl(response.data.medical_case_post_url)
                                                this.setTegnerUrl(response.data.tegner_post_url)
                                            } else {
                                                this.setCompletedNextUrl(response.data.next_link)
                                                this.setNextUrl(response.data.next_route)
                                                this.setLastUrl(response.data.previous_route)
                                                this.setSelectedFollowUpId(response.data.follow_up.id)

                                                if (this.completedNextUrl) {
                                                    setTimeout(this.redirectToNext,5000)
                                                }
                                            }

                                            this.getQuestionFromNotification().then(response => {
                                                this.refreshProgress()
                                                if (response.data.follow_up.special_type && response.data.follow_up.special_type.startsWith("scale")) {
                                                    this.updateResponse()
                                                    this.markAsDisabled = false
                                                }
                                            }).catch(reason => {
                                                //Stay here...
                                                console.log(reason)
                                                this.markAsDisabled = false
                                            })

                                        })
                                        .catch(reason => {
                                            //Stay here...
                                            console.log(reason)
                                            this.markAsDisabled = false
                                        })
                                    }
                                })
                            }
                        }, 150);

                })

            },
            removeLast() {
                this.removeLastAnswerFromNotification({score_question_answer_id: this.response}).then(response => {
                    this.response = null
                    this.btn_next = false
                    this.refreshProgress()
                    this.slider_value = 0
                    if (response.data.follow_up.special_type.startsWith("scale")) {
                        this.updateResponse()
                    }
                }).catch(reason => {
                    //Stay here..
                })

            },
            refreshProgress() {
                if (this.selectedFollowUp.question.progression > 0) {
                    this.percentProgress = (this.selectedFollowUp.question.progression / this.selectedFollowUp.question.total_questions) * 100
                }
            },
            back() {
                //this.$router.back()
                this.$router.replace({
                    name: 'patient.viewTreatment',
                    params: {
                        id: this.selectedPatient.id,
                        medical_case_id: this.selectedMedicalCase.id,
                        treatment_id: this.selectedTreatment.id}
                })
            },
            formatAnswer(text, remark) {
                if (remark !== null) {
                    return text + " - " + remark
                }
                return text
            },

            redirectToNext() {
                window.removeEventListener('beforeunload', this.listener);
                window.location.href = this.completedNextUrl
            }
        },
        watch: {
            locale() {
                this.getCurrentQuestion()
            }
        }
    }
</script>

<style scoped>
    .height-max {
        height: 100%;
        overflow: hidden;
    }


</style>
